import React from 'react';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import swal from 'sweetalert';
import Modal from 'react-bootstrap/Modal';
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from '@material-ui/core/Checkbox';
import { ThreeDots } from 'react-loader-spinner'

const selectProps = { indeterminate: isIndeterminate => isIndeterminate };



const SERVER_URL = process.env.REACT_APP_API_URL;


const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};


function SearchAndAllocateSimStock() {
  const [activeTab, setActiveTab] = useState("pageOne")
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerData, setRetailerData] = useState([])
  const [storeData, setStoreData] = useState([])
  const [rememberMe, setRememberMe] = useState(false);
  const [rememberMe1, setRememberMe1] = useState(false);
  const [allocateBox, setAllocateBox] = useState(false);
  const [retailerBox, setRetailerBox] = useState(false);
  const [pid, setPid] = useState("");
  const [retailer_code, setRetailer_code] = useState("");
  const [retailerAddress, setRetailerAddress] = useState("")  
  const [company, setCompany] = useState("")
  const [name, setName] = useState("")
  const [text, setText] = useState(false)
  const [button, setButton] = useState(false)
  const [selectedSimBaseIds, setSelectedSimBaseIds] = useState([]);
  const [seachStore, setSearchStore] = useState(false)
  const [delearDetails, setDelearDetails] = useState(false)
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [retailerDetails, setRetailerDetails] = useState(false)
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [dataTable, setDataTable] = useState(false)
  const [storeDataTable, setStoreDataTable] = useState(false)

  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const [tableView, setTableView] = useState(false);
  const[retailerDetails1,setRetailerDetails1]=useState(false);
  const [disable,setDisable]=useState(false)
  



  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = retailerData.slice(indexOfFirstRow, indexOfLastRow);
  const StoreData = storeData.slice(indexOfFirstRow, indexOfLastRow);
 
  const [formData, setFormData] = useState({
    sim_number: "",
    bundle_number: "",
    control_number: "",
    box_number: "",
    retailer_code: "",
    sim_base_ids: [],
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",

  });

  
  const handleSearch = async (e) => {
    e.preventDefault();
  
    // Check if sim_base_ids is defined
    if (!formData.sim_base_ids) {
      formData.sim_base_ids = []; 
    }
  
    if (
      formData.sim_number === "" &&
      formData.bundle_number === "" &&
      formData.control_number === "" &&
      formData.box_number === "" &&
      formData.retailer_code === "" &&
      formData.sim_base_ids.length === 0 &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      return;
    }
  
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "" && (!Array.isArray(value) || value.length > 0))
    );
  
    // Check if filteredFormData is empty
    if (Object.keys(filteredFormData).length === 0) {
      toast.error("Please fill in at least one input field for searching");
      return;
    }
  
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}get_sim_stock_data`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        setDisable(true)
        if (response.data.data.sim_bases_data !== null && response.data.data.sim_bases_data.length > 0) {
          setDataTable(true);
          setRetailerData(response.data.data.sim_bases_data);
          toast.success(response.data.message);
          console.log("retailer-data", response.data.data.sim_bases_data);
        } else {
          setDataTable(false);
          setAllocateBox(false);
          setRememberMe(false);
          setRememberMe1(false);
          toast.error("No data found during searching");
        }
        console.log("response", response.data.data);
      }
    } catch (error) {
      setDisable(true)
      console.log(error);
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });
      } else {
        toast.error(errorMessage);
      }
    }
  };
  
  















  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}get_retailer_details`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
        const data = response.data.data
        setRetailerAddress(data.retailer_address)
        setCompany(data.retailer_company_name)
        setName(data.retailer_name)
        setButton(true)
        setDelearDetails(true)
        setRetailerBox(true)
        setRetailerDetails(true)
        setRetailerDetails1(true)
        
      

        console.log("data", data)
      }
      console.log("response", response.data.message);

    } catch (error) {
      console.log(error)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);
      }
    }
  };


  const handleAllocate = async (e) => {
    e.preventDefault();
    setLoading(true)
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}allocate_sim_stock`, filteredFormData, {
        headers: headers
      });
      if (response.status === 200) {
         setLoading(false)
        const data = response.data.data
        console.log("data", data)
        // toast.success(response?.data?.message);
        const message = response.data.message
        setAllocateBox(false);
        setRetailerDetails1(false)
        setStoreDataTable(false)
        setSelectedRetailerId(null)

      
        setFormData(prevFormData => ({
          ...prevFormData,
          retailer_code:""
        }));
        swal({
          title: "",
          text:  message ,
          icon: "success",
          button: "Close"
        });
      }
      console.log("response", response.data.message);

    } catch (error) {
      setButton(false)
      // setFormData(prevFormData => ({
      //   ...prevFormData,
      //   retailer_code:""
      // }));
      console.log(error)
      setLoading(false)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      swal({
        title: "",
        text: errorMessage,
        icon: "error",
        button: "Close"
      });
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            // toast.error(message);
          });
        });

      } else {
        setButton(false)
        // toast.error(errorMessage);

      }
    }
  };





  const handleChange = (e) => {
    setDisable(false)
    const { name, value } = e.target;

    if (name === "bundle_number") {
      setFormData({ ...formData, [name]: value });
      if (/^\d{0,20}$/.test(value)) {}
    } else if (name === 'sim_number') {
      if (/^\d{0,20}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handlePidChange = (e) => {
    const value = e.target.value
    setFormData({
      ...formData,
      retailer_code: value
    });
    setPid(value)

  }



  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(retailerData.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };



  // const handleAllocateBox = (event, simBaseId) => {
  //   setAllocateBox(true);

  //   if (event.target.checked) {
  //     setSelectedSimBaseIds(prevIds => [...prevIds, simBaseId]);
  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       sim_base_ids: [...prevFormData.sim_base_ids, simBaseId]
  //     }));
  //   } else {
  //     setSelectedSimBaseIds(prevIds => prevIds.filter(id => id !== simBaseId));
  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       sim_base_ids: prevFormData.sim_base_ids.filter(id => id !== simBaseId)
  //     }));
  //   }
  // };

  // const handleAllocateBox = (event, simBaseId) => {
  //   setAllocateBox(true);
  //   if (event.target.checked) {
  //     const updatedSimBaseIds = [...selectedSimBaseIds, simBaseId];
  //     setSelectedSimBaseIds(updatedSimBaseIds);
  //     console.log("selectedsimbaseIds", selectedSimBaseIds)
  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       sim_base_ids: updatedSimBaseIds
  //     }));
  //   } else {
  //     const updatedSimBaseIds = selectedSimBaseIds.filter(id => id !== simBaseId);
  //     setSelectedSimBaseIds(updatedSimBaseIds);
  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       sim_base_ids: updatedSimBaseIds
  //     }));
  //     if (updatedSimBaseIds.length === 0) {
  //       setAllocateBox(false);
  //       setFormData({ retailer_code: "" })
  //     }
  //   }
  // };



  const handleSetRememberMe = (e) => {
    setRememberMe(prevState => {
      const newRememberMeState = !prevState;
      setRetailerBox(newRememberMeState);
      return newRememberMeState;
    });
    setRememberMe1(false);
    setDelearDetails(false);

  };

  const handleSetRememberMe1 = (e) => {
    setRememberMe1(prevState => {
      const newRememberMe1State = !prevState;
      setSearchStore(newRememberMe1State);
      return newRememberMe1State;
    });
    setRememberMe(false);
    setRetailerDetails(false)
    setRetailerDetails1(false)
    setFormData(prevFormData => ({
      ...prevFormData,
      retailer_code: "",
      store_name: "",
      email: "",
      abn: "",
      state: "",
      city: "",
      postcode: "",
      street_name: "",
    }));
  };





  // const showAlert = () => {
  //   // Create the content element
  //   const content = document.createElement('div');
  //   content.innerHTML = `
  //
  //     <h1>Hello, World!</h1>
  //     <p>This is some HTML content that is conditionally rendered.</p>
  //   `;

  //   // Show the SweetAlert modal with custom content
  //   swal({
  //     title: "Hello, World!",
  //     content: content,
  //     icon: "info",
  //     button: "Close"
  //   });
  // };








  /**    functions for search store */


  const handleBack = () => {
    setSearchStore(false)
    setDelearDetails(false)
    setRetailerBox(false)
    setRetailerDetails1(false)
    setRememberMe1(false)
    setAllocateBox(false)
    setButton(false)

    // setFormData({
    //   sim_number: "",
    //   bundle_number: "",
    //   control_number: "",
    //   box_number: "",
    //   retailer_code: "",
    // })
    handleClear();

  }

  const handleStoreSearch = async (e) => {
    e.preventDefault();
   
    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      setTableView(false);
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter post code or city name");
      setTableView(false);
      return;
    } else if (formData.state && (formData.city === "" &&formData.postcode === "")) {
      toast.error("Please enter street name or post code");
      setTableView(false);
      return;
    }
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
        headers: headers
      });
      
      if (response.status === 200) {
        setDisable(true)
        console.log("retailerData", response.data.data)
        console.log("length", response.data.data.length)
        if (response.data.data !== null && response.data.data.length > 0) {
          setCurrentPage(1)
          setStoreDataTable(true)
          setDataTable(false)
          
          setStoreData(response.data.data)
          setRetailerData(response.data.data)
          // setStoreData(response.data.data.search_store_data)
          // setRetailerData(response.data.data.search_store_data)
          toast.success(response.data.message);
        } else {
          setStoreDataTable(false)
          setRetailerBox(false)
          setRememberMe1(false);
          setDelearDetails(false)
          setDelearDetails(false)
          setRetailerAddress("") 
          setCompany("")
          setName("")
          setFormData({
            retailer_code:"",
          })

          toast.error("No data found during searching");
        }
      }

    } catch (error) {
      setDisable(true)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };



  const handleAllocateRetailer = (event, retailer_id) => {
    setAllocateBox(true);
    if (event.target.checked) {
      setSelectedRetailerId(retailer_id);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: retailer_id
      }));
      //  handleSubmit();
    } else {
      setSelectedRetailerId(null);
      setFormData((prevFormData) => ({
        ...prevFormData,
        retailer_code: ""
      }));
    }
  };


  useEffect(() => {
    if (selectedRetailerId !== null) {
      handleSubmit();
    }
  }, [selectedRetailerId]);




  const handleCheckAll = (event) => {
    const isChecked = event.target.checked;
    setIsAllChecked(isChecked);
    setAllocateBox(isChecked);

    if (isChecked) {
      const allIds = retailerData
        .filter(data => !data.shop_code)
        .map(data => data.sim_base_id);
      setSelectedSimBaseIds(allIds);
      setFormData(prevFormData => ({
        ...prevFormData,
        sim_base_ids: allIds
      }));
    } else {
      setSelectedSimBaseIds([]);
      setFormData(prevFormData => ({
        ...prevFormData,
        sim_base_ids: []
      }));
      setAllocateBox(false);
    }
  };

  const handleClear = () => {
    setFormData({
    sim_number: "",
    bundle_number: "",
    control_number: "",
    box_number: "",
    retailer_code: "",
    sim_base_ids: [],
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",
    });
    setStoreDataTable(false)
    setRetailerDetails(false)
    setRetailerDetails1(false)
    setSelectedRetailerId(null)
   
  };

   const handleClear1=()=>{
    setFormData({
      sim_number: "",
      bundle_number: "",
      control_number: "",
      box_number: "",
      retailer_code: "",
    });
      setDataTable(false)
      setAllocateBox(false)
      setRetailerBox(false)
      setDelearDetails(false) 
      setRememberMe(false)
      setButton(false)


   }

  const columns = [

    {
      id: 1,
      name: "Box Number",
      selector: (row) => row.box_number,
    },
    {
      id: 2,
      name: "Bundle Number",
      selector: (row) => row.bundle_number,
    },
    {
      id: 3,
      name: "Control Number",
      selector: (row) => row.control_number,
    },
    {
      id: 4,
      name: "Sim Number",
      selector: (row) => row.sim_number,
    },
    {
      id: 5,
      name: "Channel",
      selector: (row) => row.channel,
    },
    {
      id: 6,
      name: "Retailer ID",
      selector: (row) => row.shop_code ,
    },
    {
      id: 7,
      name: "Retailer Company",
      selector: (row) => row.retailer_company_name,
    },
    {
      id: 8,
      name: "Plan Name",
      selector: (row) => row.offerName,
    },


  ];








  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };


  const handleChanges = ({ selectedRows }) => {
    const updatedSimBaseIds = selectedRows.map(row => row.sim_base_id);
    setAllocateBox(true);
    setFormData(prevFormData => ({
      ...prevFormData,
      sim_base_ids: updatedSimBaseIds
    }));
    setSelectedRows(selectedRows);
};



  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  }

  const rowDisabledCriteria = row => row.shop_code;


  // const customStyles = {
  //   gyksGC: {
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }
  //   },
  //   fKWVwL: {
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }

  //   },
  //   kmBKjq:{
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }

  //   },
  //   joLmgr:{
  //     style: {
  //       whiteSpace: "normal",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis"
  //     }
  //   },

  //   rows: {
  //     style: {
  //       border: '1px solid #ccc!important'
  //     },
  //   },
  //   headCells: {
  //     style: {
  //       backgroundColor: '#f0f0f0',
  //       border: '1px solid #fff'
  //     },
  //   },
  //   cells: {
  //     style: {
  //       borderBottom: '2px solid #f0f0f0'
  //     },
  //   },

 
  // };

  const customStyles = {
    gyksGC: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    fKWVwL: {
      style: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }

    },
    rows: {
      style: {
        border: '1px solid #ccc', // Add border to rows
      },
    },
    headCells: {
      style: {
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc', // Add border to header cells
      },
    },
    cells: {
      style: {
        border: '1px solid #ccc', // Add border to individual cells
      },
    },
  };












  return (
    <DashboardLayout>
      <DashboardNavbar />
      <>
        {seachStore ? (
          <div>
              {loading && (
            <div style={styles.wrapper}>
              <ThreeDots
                visible={loading}
                height="80"
                width="80"
                color="#C11D6C"
                radius="9"
                ariaLabel="three-dots-loading"
              />
            </div>
          )}

            <div className="formbold-main-wrapper">
              <div className="formbold-form-wrapper">
                <h5 style={{ textAlign: "center" }}>Search Store And Allocate SIM Stock</h5>
                <form action="" method="" onSubmit={handleStoreSearch} autoComplete='off'>
                  <div className="formbold-mb-5 formbold-pt-3">
                    <label className="formbold-form-label formbold-form-label-2">
                    </label>
                    <div className="flex flex-wrap formbold--mx-3">
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Store Name
                          </label>
                          <input
                            type="text"
                            name="store_name"
                            id="store_name"
                            placeholder="Enter Store Name"
                            className="formbold-form-input"
                            value={formData.store_name}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Email  Address
                          </label>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter Email Address"
                            className="formbold-form-input"
                            value={formData.email}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Retailer ID
                          </label>
                          <input
                            type="text"
                            name="retailer_code"
                            id="retailer_code"
                            placeholder="Enter Retailer ID"
                            className="formbold-form-input"
                            value={formData.retailer_code}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            ABN
                          </label>
                          <input
                            type="text"
                            name="abn"
                            id="abn"
                            placeholder="Enter ABN"
                            className="formbold-form-input"
                            value={formData.abn}
                            onChange={handleChange}
                            maxLength={12}
                            autoComplete='off'
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            City 
                          </label>
                          <input
                            type="text"
                            name="city"
                            id="city"
                            placeholder="Enter City Name"
                            className="formbold-form-input"
                            value={formData.city}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Post Code
                          </label>
                          <input
                            type="text"
                            name="postcode"
                            id="postcode"
                            placeholder="Enter Post Code"
                            className="formbold-form-input"
                            value={formData.postcode}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Street Name
                          </label>
                          <input
                            type="text"
                            name="street_name"
                            id="street_name"
                            placeholder="Enter Street Name"
                            className="formbold-form-input"
                            value={formData.street_name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <label htmlFor="store_name" className="formbold-form-label">
                          State
                        </label>
                        <select
                          className="formbold-form-input"
                          name="state"
                          id="state"
                          value={formData.state}
                          onChange={handleChange}
                        >
                          <option value="">Select State</option>
                          <option value="Act">ACT</option>
                          <option value="NSW">NSW</option>
                          <option value="NIT">NIT</option>
                          <option value="QLD">QLD</option>
                          <option value="SA">SA</option>
                          <option value="TAS">TAS</option>
                          <option value="VIC">VIC</option>
                          <option value="WA">WA</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <div className="search-store-buttons">
                  <button className="search-store-button" type="submit" disabled={disable}>Search</button>
                  {
                    storeDataTable&& (
                      <button className="search-store-button" onClick={handleClear}>Clear</button>
                    )
                  }
                </div>

                </form>

                {storeDataTable && (
                  <div className="container" style={{ marginTop: "10px" }}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <table id="mytable" className="table table-bordred ">
                            <thead>
                              <tr>
                                <th>No</th>
                                <th>Allocate</th>
                                <th>Retailer ID</th>
                                <th>Retailer Name</th>
                                <th>Store Address</th>
                                <th>Email Address</th>
                              </tr>
                            </thead>
                            <tbody>

                              {StoreData.map((data, index) => (
                                <tr key={indexOfFirstRow + index}>
                                  <td>{indexOfFirstRow + index + 1}</td>
                                  <td>
                                    <input type="checkbox" className="checkthis" checked={selectedRetailerId === data.retailer_code} onChange={(event) => handleAllocateRetailer(event, data.retailer_code)} />
                                  </td>
                                  <td>{data.retailer_code || "N/A"}</td>
                                  <td>{data.retailer_company_name || "N/A"}</td>
                                  <td>{data.retailer_store_address|| "N/A"}</td>
                                  <td>{data.retailer_email || "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="clearfix" />

                          <div className="pagination">
                            {currentPage > 1 && (
                              <button className="previous" onClick={handlePrevious}>
                                Previous
                              </button>
                            )}
                            {currentPage < Math.ceil(retailerData.length / rowsPerPage) && (
                              <button className="next" onClick={handleNext}>
                                Next
                              </button>
                            )}
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                )}


                {retailerDetails1 && (
                  <div classname="formbold-main-wrapper">
                    <div classname="formbold-form-wrapper">
                      <div className='trail delar-box'>
                        <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"} >
                          <SoftBox mb={2}>
                            <div className='details'>
                              <h6 className='details-name'>Dealer Name:<span>&nbsp;</span> {name}</h6>
                              <h6 className='details-company'>Company/Store Name: <span>&nbsp;</span>  {company}</h6>
                              <h6 className='details-address'>Dealer Address:<span>&nbsp;</span> {retailerAddress}</h6>
                            </div>
                          </SoftBox>

                          <SoftBox mt={2} mb={2} className="allocate" >
                            <SoftButton variant="gradient" className="allocate-button" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                              Allocate
                            </SoftButton>
                          </SoftBox>
                        </SoftBox>
                      </div>
                    </div>
                  </div>
                )}
                <button className='handle-back' onClick={handleBack}> back</button>
              </div>
            </div>
          </div>
        ) :
            
          <div>

            {loading && (
              <div style={styles.wrapper}>
                <ThreeDots
                  visible={loading}
                  height="80"
                  width="80"
                  color="#C11D6C"
                  radius="9"
                  ariaLabel="three-dots-loading"
                />
              </div>
            )}
            <div className="formbold-main-wrapper">
              <div className="formbold-form-wrapper">
                <h5 style={{ textAlign: "center" }}>Search And Allocate SIM Stock</h5>
                <form action="" method="" onSubmit={handleSearch} autoComplete='off'>
                  <div className="formbold-mb-5 formbold-pt-3">
                    <label className="formbold-form-label formbold-form-label-2">
                    </label>
                    <div className="flex flex-wrap formbold--mx-3">
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Box Number
                          </label>
                          <input
                            type="text"
                            name="box_number"
                            id="box_number"
                            placeholder="Enter Box Number"
                            className="formbold-form-input"
                            value={formData.box_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Bundle Number
                          </label>
                          <input
                            type="text"
                            name="bundle_number"
                            id="bundle_number"
                            placeholder="Enter Bundle Number"
                            className="formbold-form-input"
                            value={formData.bundle_number}
                            onChange={handleChange}
                            autoComplete="off"
                            maxLength={20}
                          />
                        </div>
                      </div>

                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            SIM Number 
                          </label>
                          <input
                            type="tel"
                            name="sim_number"
                            id="sim_number"
                            placeholder="Enter SIM Number"
                            className="formbold-form-input"
                            value={formData.sim_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Control Number
                          </label>
                          <input
                            type="text"
                            name="control_number"
                            id="control_number"
                            placeholder="Enter Control Number"
                            className="formbold-form-input"
                            value={formData.control_number}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="w-full sm:w-half formbold-px-3">
                        <div className="formbold-mb-5">
                          <label htmlFor="store_name" className="formbold-form-label">
                            Retailer ID 

                          </label>
                          <input
                            type="text"
                            name="retailer_code"
                            id="retailer_code"
                            placeholder="Enter Retailer ID"
                            className="formbold-form-input"
                            value={formData.retailer_code}
                            onChange={handleChange}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <button className="allocate-sim-button" type="submit" >Submit</button>
                  </div> */}

                  <div className="search-store-buttons">
                    <button className="search-store-button" type="submit" disabled={disable}><i class="fa fa-search"></i> Search</button>
                    {
                      dataTable && (
                        <button className="search-store-button" type="button" onClick={handleClear1}>
                          Clear
                        </button>
                      )
                    }
                  </div>
                </form>
                {dataTable && (
                 <div className="data-dummy-table">
                 <DataTable
                   title="Search And Allocate Sim Stock Details"
                   columns={columns}
                   data={retailerData}
                   pagination
                   paginationComponentOptions={paginationComponentOptions}
                   selectableRows
                   onSelectedRowsChange={handleChanges}
                   clearSelectedRows={toggledClearRows}
                   selectableRowDisabled={rowDisabledCriteria}
                   customStyles={customStyles}
                 />
               </div>
                )}


                {allocateBox && (
                  <div style={{marginTop:"50px"}}>
                    <div classname="formbold-main-wrapper">
                      <div classname="formbold-form-wrapper">
                        <div className='trail'>
                          <div className='sub-trail'>
                            <SoftBox display="flex" alignItems="center">
                              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                              <SoftTypography
                                variant="button"
                                fontWeight="regular"
                                onClick={handleSetRememberMe}
                                sx={{ cursor: "pointer", userSelect: "none" }}
                              >
                                &nbsp;&nbsp;Assign directly using Retailer ID
                              </SoftTypography>
                            </SoftBox>

                            <SoftBox display="flex" alignItems="center" className="second-Button">
                              <Switch checked={rememberMe1} onChange={handleSetRememberMe1} />
                              <SoftTypography
                                variant="button"
                                fontWeight="regular"
                                onClick={handleSetRememberMe1}
                                sx={{ cursor: "pointer", userSelect: "none" }}
                              >
                                &nbsp;&nbsp;Search Store & Allocate SIM Stock
                              </SoftTypography>
                            </SoftBox>
                          </div>

                          {retailerBox && (
                            <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"}>
                              <SoftBox mb={2}>
                                <SoftBox>
                                  <SoftTypography component="label" variant="caption" fontWeight="bold" style={{ fontSize: "20px" }}>
                                    Enter Retailer ID  <span class="astrix-color">*</span>
                                  </SoftTypography>
                                </SoftBox>
                                <SoftInput type="text" placeholder="Enter Retailer Id" name="retailer_code" value={formData.retailer_code} autoComplete='off' onChange={handlePidChange} />
    
                                {delearDetails && (
                                  <div className='details'>
                                    <h6 className='details-name'>Dealer Name: <span>&nbsp;</span>{name}</h6>
                                    <h6 className='details-company'>Company/Store Name:<span>&nbsp;<span>&nbsp;</span></span>{company}</h6>
                                    <h6 className='details-address'>Dealer Address:<span>&nbsp;</span><span>&nbsp;</span>{retailerAddress}</h6>
                                  </div>
                                )}

                              </SoftBox>
                              {button ? (
                                <SoftBox mt={2} mb={2} style={{ paddingBottom: "60px" }}>
                                  <SoftButton variant="gradient" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                                    Allocate
                                  </SoftButton>
                                </SoftBox>
                              ) : (
                                <SoftBox mt={2} mb={2} style={{ paddingBottom: "60px" }}>
                                  <SoftButton variant="gradient" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleSubmit}>
                                    Search
                                  </SoftButton>
                                </SoftBox>
                              )}
                            </SoftBox>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        }

        <>
        </>
      </>
    </DashboardLayout>

  )
}
export default SearchAndAllocateSimStock